import { useNavigate } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Navbar } from "@/components/Navbar";
import { useLang } from "@/context/LanguageContext";

export function AccountShell({ title, children, testid, width = "max-w-3xl", back = "/account" }) {
  const navigate = useNavigate();
  const { dir, lang } = useLang();
  const Back = dir === "rtl" ? ChevronRight : ChevronLeft;
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className={`${width} mx-auto px-5 w-full py-8 flex-1`} data-testid={testid}>
        <button onClick={() => navigate(back)} className="text-slate-500 text-sm mb-4 flex items-center gap-1" data-testid="back-to-account">
          <Back className="w-4 h-4" /> {lang === "en" ? "Back" : "رجوع"}
        </button>
        <h1 className="font-headline text-2xl font-bold mb-6">{title}</h1>
        {children}
      </main>
    </div>
  );
}
